module.exports = __webpack_public_path__ + "img/111.8f0bfda4.png";